  <!-- MIGAS DE PAN Y TÍTULO -->
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="bg-second-migas">
    <div class="container mt-cab-fixed">
      <div class="pre-content">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Gestores/Acondicionadores</li>
            <li class="breadcrumb-item">Búsqueda de Gestores y/o Acondicionadores</li>
          </ol>
        </nav>
        <div class="content-title">
          <h2 class="title-pag">Búsqueda de Gestores y/o Acondicionadores</h2>
        </div>
      </div>
    </div>
  </div>
  <!-- FIN MIGAS DE PAN Y TÍTULO -->
  <!-- CONTENIDO -->

  <div class="container-form">
    <!-- Barra de filtros aplicados -->
    <div class="filtros-bar">
      <div class="filtros-aplicados">
        <span class="filtros-label">Filtros aplicados</span>
        <span *ngFor="let filtro of filtrosAplicados" class="filtro-chip">
          {{filtro.label}}
          <button type="button" class="chip-remove" (click)="quitarFiltro(filtro)">×</button>
        </span>
      </div>
      <button type="button" class="btn-toggle-filtros" (click)="toggleFiltros()">
        <mat-icon>tune</mat-icon>
        {{ mostrarFiltros ? 'Ocultar Filtros' : 'Ver Filtros' }}
      </button>
    </div>
    <!-- Formulario de búsqueda -->
    <form *ngIf="mostrarFiltros" class="container form-search py-3" [formGroup]="searchForm">
      <div class="d-flex flex-wrap" style="gap: 1rem;">
        <!-- Campo 1 -->
        <div style="flex: 1 1 120px; max-width: 255px;">
          <label for="idGestor">ID. Gestor/Acondicionador</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="idGestor" id="idGestor" placeholder="ID. Gestor/Acondicionador" type="text" (keydown)="onlyNumberKey($event)">
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 2 -->
        <div style="flex: 1 1 180px; max-width: 250px;">
          <label for="codigo_documento">Documento (NIE,NIF) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="codigo_documento" id="codigo_documento" placeholder="Documento (NIE,NIF)"
                type="text">
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 3 -->
        <div style="flex: 2 1 350px; max-width: 550px;">
          <label for="razon_social">Razón Social </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="razon_social" id="razon_social" placeholder="Razón Social" type="text">
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 4 -->
        <div style="flex: 1 1 200px; max-width: 270px;">
          <label for="provincia_fisica">Provincia (Dirección Física) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="provincia_fisica" id="provincia_fisica" placeholder="-- Provincia --" [compareWith]="compareProvincia">
                <mat-option *ngFor="let provincia of provinciaArray" [value]="provincia">
                  {{ provincia.nombre }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('provincia_fisica')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'provincia_fisica')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 5 -->
        <div style="flex: 1 1 200px; max-width: 270px;">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="estado" id="estado" placeholder="-- Estado --" multiple [compareWith]="compareEstado">
                <mat-option *ngFor="let des of estadoArray" [value]="des">
                  {{ des.descripcion }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('estado')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'estado')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 6 -->
        <div style="flex: 1 1 180px; max-width: 250px;">
          <label for="nima">NIMA </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="nima" id="nima" placeholder="Nima" type="text">
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 7 -->
        <div style="flex: 1 1 150px; max-width: 180px;">
          <label for="acuerdoEnv">Acuerdo con Envalora</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="acuerdoEnv" id="acuerdoEnv" placeholder="Seleccionar">
                <mat-option *ngFor="let item of optionArray" [value]="item.value">
                  {{ item.value }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('acuerdoEnv')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'acuerdoEnv')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 8 -->
        <div style="flex: 2 1 300px; max-width: 350px;"
          *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="convAcondicionador">Convenio acondicionador firmado con Envalora</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="convAcondicionador" id="convAcondicionador" placeholder="Seleccionar">
                <mat-option *ngFor="let item of optionArray" [value]="item.value">
                  {{ item.value }}
                </mat-option>
              </mat-select>
              <span *ngIf="showClearButton('convAcondicionador')" tabindex="0" class="ng-clear-wrapper"
                (click)="clearSelection($event,'convAcondicionador')">
                <span aria-hidden="true" class="ng-clear">×</span>
              </span>
            </mat-form-field>
          </div>
        </div>
        <!-- Campo 9 -->
        <div style="flex: 1 1 180px; max-width: 200px;">
          <label for="auto_peligrosidad">Autorización de peligrosos</label>
          <div class="custom-mat-field">
            <mat-checkbox class="margin-left-10" formControlName="auto_peligrosidad" color="primary"></mat-checkbox>
          </div>
        </div>
        <!-- Campo 10 -->
        <div style="flex: 0 1 100px; max-width: 130px;">
          <label for="gestores">Gestores</label>
          <div class="custom-mat-field">
            <mat-checkbox class="margin-left-10" formControlName="gestores" color="primary"></mat-checkbox>
          </div>
        </div>
        <!-- Campo 11 -->
        <div style="flex: 0 1 120px; max-width: 150px;">
          <label for="acondicionadores">Acondicionadores</label>
          <div class="custom-mat-field">
            <mat-checkbox class="margin-left-10" formControlName="acondicionadores" color="primary"></mat-checkbox>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;">
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
                <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
              <mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="orden">Orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="orden" id="orden" placeholder="Seleccionar" multiple>
                <mat-option *ngFor="let item of orden" [value]="item.codigo">
                  {{item.descripcionCorta}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1 1 200px; max-width: 200px;" *ngIf="canViewResource('PO-ENV-GEST')||canViewResource('PO-ENV-CONS')">
          <label for="tipoOrden">Tipo de orden</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <mat-select formControlName="tipoOrden" id="tipoOrden" placeholder="Seleccionar">
              <mat-option [value]="'ASC'">Ascendente</mat-option>
                <mat-option [value]="'DESC'">Descendente</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <!-- <div class="col-sm flex-grow-1" *ngIf="canViewResource('PO-ENV-GEST') === false || canViewResource('PO-ENV-CONS') === false"></div> -->
      </div>
    </form>
        <form class="container-fluid form-search py-3">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="clearSearcher()">Limpiar</button>
      <button type="button" class="btn btn-primary" (click)="searchData()">Buscar</button>
    </div>
  </form>
    <!-- FIN Formulario de búsqueda -->
  </div>
  <div class="bg-second-table-info pt-3 pb-5">
    <div *ngIf="flagSearch; else messageClear" class="container">
      <div class="actions-table">
        <div class=""><span class="align-middle tit-table">{{ recordsTotal }} registros encontrados</span></div>
        <div class="text-right">
          <div class="d-inline" *ngIf="this.canViewResource('AD-ENV-GEST')">
            <div class="d-inline dropdown show">
              <a class="btn btn-outline-primary" role="button" aria-haspopup="true" aria-expanded="false"
                style="margin-right:5px;" (click)="comprobarCambioEstado()">
                <span>Cambiar estado</span></a>
            </div>
          </div>
          <div class="d-inline">

            <div class="d-inline dropdown show">
              <a (click)="exportarExcel()" class="btn btn-outline-primary" role="button" aria-haspopup="true"
                aria-expanded="false">
                <span class="mr-3">Exportar</span></a>
            </div>
          </div>
        </div>
      </div>
      <div class="card-tabla-proy">
        <div class="card-body">
          <div class="datatable-wrapper datatable-loading no-footer sortable searchable fixed-columns">
            <div class="datatable-container table-responsive">
              <!-- TABLA Listado con resultados de búsqueda -->
              <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (checked)="checked($event)"
                (actionButton)="action($event)"></lib-ge-table>
              <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
                <div class="d-flex mt-2">
                  <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
                    (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
                  </ngb-pagination>
                </div>

                <div class="mt-2 selectPage">
                  <label for="itemsPerPage">Mostrar:</label>
                  <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
                    <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
                  </select>
                </div>
              </div>
              <!-- FIN TABLA Listado con resultados de búsqueda -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-template #messageClear>
      <div class="mensaje-container">
        <p class="mensaje-linea">No hay resultados de búsqueda, por favor seleccione, al menos, un criterio en el
          formulario</p>
        <p class="mensaje-linea"></p>
      </div>
    </ng-template>
  </div>
